import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/logo-2.png';
import _imports_1 from '@/assets/home/驾驶舱.svg';
import _imports_2 from '@/assets/home/工作台.svg';
import _imports_3 from '@/assets/home/cart.png';
const _hoisted_1 = {
    class: "header-inline flex justify-between h-16 items-center"
};
const _hoisted_2 = {
    class: "logo-icon"
};
const _hoisted_3 = {
    class: "nav-wrap hidden min-[991px]:flex items-center justify-end gap-x-4 lg:gap-x-8 flex-shrink-0"
};
const _hoisted_4 = [
    "onMouseenter"
];
const _hoisted_5 = {
    class: "absolute z-10 pt-2 top-full -left-2"
};
const _hoisted_6 = {
    class: "overflow-hidden bg-white shadow-lg ring-1 ring-gray-900/5 w-fit"
};
const _hoisted_7 = {
    class: "btn-wrap hidden min-[991px]:flex items-center justify-end h-full"
};
const _hoisted_8 = {
    key: 0,
    class: "flex items-center gap-x-3 md:gap-x-6"
};
const _hoisted_9 = {
    class: "relative"
};
const _hoisted_10 = [
    "id"
];
const _hoisted_11 = {
    key: 0,
    class: "absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center leading-none"
};
const _hoisted_12 = {
    class: "flex items-center justify-center mr-10px min-w-30 max-w-50 grow-0 shrink-0 cursor-pointer text-[16px] leading-[128%] text-[#3284ff]"
};
const _hoisted_13 = {
    class: ""
};
const _hoisted_14 = {
    class: "max-h-[500px] overflow-y-auto overflow-x-hidden"
};
const _hoisted_15 = [
    "onClick"
];
const _hoisted_16 = {
    key: 2,
    class: "flex items-center h-full"
};
const _hoisted_17 = {
    class: "flex items-center -mr-2 min-[991px]:hidden flex-shrink-0"
};
const _hoisted_18 = {
    class: "pt-2 pb-3 space-y-1"
};
const _hoisted_19 = {
    class: "pt-4 pb-3 border-t border-gray-200"
};
const _hoisted_20 = {
    class: "flex items-center gap-x-3 px-4"
};
const _hoisted_21 = {
    key: 0,
    class: "pt-4 pb-3 border-t border-gray-200"
};
const _hoisted_22 = {
    class: "flex items-center px-4"
};
const _hoisted_23 = {
    class: "shrink-0"
};
const _hoisted_24 = [
    "src"
];
const _hoisted_25 = {
    class: "ml-3"
};
const _hoisted_26 = {
    class: "text-base font-medium text-gray-800"
};
const _hoisted_27 = {
    class: "text-sm font-medium text-gray-500"
};
const _hoisted_28 = {
    key: 1,
    class: "pt-4 pb-3 border-t border-gray-200"
};
const _hoisted_29 = {
    class: "flex items-center gap-x-3 px-4"
};
import { computed, onMounted, onUnmounted, ref, unref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useThrottleFn } from '@vueuse/core';
import { ElIcon } from 'element-plus';
import { Select, CaretTop, CaretBottom } from '@element-plus/icons-vue';
import { Disclosure, DisclosureButton, DisclosurePanel, PopoverGroup } from '@headlessui/vue';
import { Bars3Icon, ChevronDownIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { useScroll } from '@/hooks/useScroll';
import { getAccountInfo, switchAccountInfo } from '@/api/login';
import { OverflowTooltip } from '@/components/CustomTooltip';
import useUserStore from '@/store/modules/user';
import useAppStore from '@/store/modules/app';
import { NAV_CART_ID } from '@/utils/cartAnimation';
import { PERSONAL_DEPT_ID } from '@/constant';
import { getCartList } from '@/api/cart';
// 默认头像 SVG（当 userStore.avatar 为空时使用）
import { useToMng } from '@/hooks/useToMng';
export default {
    __name: 'Navbar',
    setup (__props) {
        const defaultAvatarSvg = 'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">' + '<rect width="40" height="40" fill="#e0e7ff" rx="20"/>' + '<circle cx="20" cy="16" r="6" fill="#94a3b8"/>' + '<path d="M8 35c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#94a3b8"/>' + '</svg>');
        const route = useRoute();
        const router = useRouter();
        const userStore = useUserStore();
        const appStore = useAppStore();
        const hoveredNav = ref(null);
        const navigation = [
            {
                name: '首页',
                href: '/home',
                num: '0'
            },
            // { name: '行业流通专区', href: '/trade-center', num: '1' },
            {
                name: '甬数云市',
                href: '/cloud-market/home',
                num: '1',
                children: [
                    {
                        name: '甬数云市 · 专区',
                        href: '/cloud-market/zone'
                    },
                    {
                        name: '甬数云市 · 企业',
                        href: '/cloud-market/enterprise'
                    },
                    {
                        name: '甬数云市 · 工坊',
                        href: '/cloud-market/workshop'
                    }
                ]
            },
            // {
            //   name: '数商资源中心',
            //   href: '/data-company',
            //   num: '1',
            //   // children: [
            //   //   {
            //   //     name: '数商生态',
            //   //     description: '数商生态',
            //   //     href: '/data-company',
            //   //     icon: ChartPieIcon,
            //   //   },
            //   //   {
            //   //     name: '生态共建',
            //   //     description: '生态共建',
            //   //     href: '/ecological-build',
            //   //     icon: CursorArrowRaysIcon,
            //   //   },
            //   // ],
            // },
            // { name: '全量资源市场', href: '/market', num: '1' },
            // { name: '新闻资讯', href: '/news', num: '0' },
            {
                name: '公共数据利用',
                href: '/common-data',
                num: '0'
            },
            {
                name: '数据跨域流通',
                href: '/data-mobility',
                num: '0'
            },
            {
                name: '全量目录检索',
                href: '/directory-search',
                num: '0'
            },
            {
                name: '生态合作',
                href: '/eco-collab',
                num: '0'
            },
            {
                name: '规则指南',
                href: '/rules',
                num: '0'
            },
            {
                name: '关于我们',
                href: '/about-us',
                num: '0'
            }
        ];
        const userNavigation = [
            //   { name: 'Your Profile', href: '#' },
            //   { name: 'Settings', href: '#' },
            //   { name: '用户中心' },
            {
                name: '退出登录',
                href: '#'
            }
        ];
        const { scrollTop } = useScroll();
        const handleCommand = (item)=>{
            if (item.name === '退出登录') {
                userStore.logOut().then(()=>{
                    location.href = '/';
                });
            }
        };
        const goEntCenter = ()=>{
            useToMng();
        };
        const innerWidth = ref(window.innerWidth);
        // 判断宽度是否大于1800
        const isLargeWidth = computed(()=>{
            return innerWidth.value > 1800;
        });
        // 监听窗口大小变化
        const handleResize = useThrottleFn(()=>{
            innerWidth.value = window.innerWidth;
        }, 100);
        onMounted(()=>{
            window.addEventListener('resize', handleResize);
            if (userStore.name) {
                initInfo();
                fetchCartCount();
            }
            window.addEventListener('cart-updated', handleCartUpdated);
        });
        onUnmounted(()=>{
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('cart-updated', handleCartUpdated);
        });
        const loginOut = ()=>{
            userStore.logOut().then(()=>{
                location.href = '/';
            });
        };
        const isAccountPopupHide = ref(false);
        const enterpriseList = ref([]);
        const currentDeptId = ref();
        const userDepId = ref();
        const initInfo = async ()=>{
            Promise.all([
                getAccountInfo()
            ]).then((param)=>{
                let [accountRes] = param;
                var _data_depts;
                const { data } = accountRes;
                enterpriseList.value = (data === null || data === void 0 ? void 0 : (_data_depts = data.depts) === null || _data_depts === void 0 ? void 0 : _data_depts.filter((v)=>v.deptId !== PERSONAL_DEPT_ID)) || [];
                currentDeptId.value = (data === null || data === void 0 ? void 0 : data.currentDeptId) || '';
                // 将currentDeptId 缓存到userStore
                userStore.setCurrentDeptId(currentDeptId.value);
                userDepId.value = PERSONAL_DEPT_ID;
            });
        };
        const showAccount = ref(false);
        const handleShowAccount = ()=>{
            isAccountPopupHide.value = false;
            showAccount.value = true;
        };
        const name = computed(()=>{
            if (currentDeptId.value === PERSONAL_DEPT_ID) {
                return userStore.nickName || '未登录';
            } else {
                var _enterpriseList_value_find;
                return ((_enterpriseList_value_find = enterpriseList.value.find((v)=>v.deptId === currentDeptId.value)) === null || _enterpriseList_value_find === void 0 ? void 0 : _enterpriseList_value_find.deptName) || '-';
            }
        });
        const handlePersonClick = ()=>{
            handleEnterpriseClick(unref(userDepId) || '');
        };
        const switchLoading = ref(false);
        const handleEnterpriseClick = async (deptId)=>{
            if (unref(currentDeptId) === deptId || !deptId || switchLoading.value) {
                return;
            }
            // 调用切换账号信息
            try {
                switchLoading.value = true;
                const { code } = await switchAccountInfo(deptId);
                // 执行刷新路由等流程
                if (code === 200) {
                    router.push('/').then(()=>{
                        // 在路由跳转完成后再刷新页面
                        window.location.reload();
                    });
                }
                switchLoading.value = false;
            } catch (error) {
                console.error('切换账号信息失败:', error);
                switchLoading.value = false;
            }
        };
        const goCart = ()=>{
            router.push('/cart');
        };
        // 购物车数量
        const cartCount = ref(0);
        const fetchCartCount = async ()=>{
            if (!userStore.name) return;
            try {
                const { data } = await getCartList(null);
                if (data === null || data === void 0 ? void 0 : data.detail) {
                    cartCount.value = data.detail.reduce((sum, ent)=>{
                        var _ent_products;
                        return sum + (((_ent_products = ent.products) === null || _ent_products === void 0 ? void 0 : _ent_products.length) || 0);
                    }, 0);
                }
            } catch (e) {
            // ignore
            }
        };
        // 监听购物车更新事件
        const handleCartUpdated = ()=>{
            fetchCartCount();
        };
        // 监听用户登录状态变化
        watch(()=>userStore.name, (newName)=>{
            if (newName) {
                fetchCartCount();
            } else {
                cartCount.value = 0;
            }
        });
        // 判断菜单项是否处于 active 状态
        const isActive = (item)=>{
            // 精确匹配当前路由路径
            if (route.path === item.href) return true;
            // 匹配路由 meta 中声明的 active 归属
            if (route.meta.active === item.href) return true;
            // 前缀匹配：当前路径以菜单 href 开头（如 /news/detail 匹配 /news）
            if (item.href !== '/' && route.path.startsWith(item.href + '/')) return true;
            // 有子菜单时，检查当前路由是否匹配任意子菜单
            if (item.children) {
                return item.children.some((child)=>route.path === child.href || route.meta.active === child.href || child.href !== '/' && route.path.startsWith(child.href + '/'));
            }
            return false;
        };
        // 根据 active 状态和滚动位置返回对应的样式类
        const getNavActiveClass = (item)=>{
            const active = isActive(item);
            if (route.path === '/home' && scrollTop.value < 100) {
                return active ? 'border-indigo-500 text-blue-500 font-semibold' : 'border-transparent text-black hover:opacity-50';
            }
            return active ? 'border-indigo-500 text-blue-500 font-semibold' : 'border-transparent hover:border-gray-300 hover:text-gray-700';
        };
        return (_ctx, _cache)=>{
            const _component_router_link = _resolveComponent("router-link");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_popover = _resolveComponent("el-popover");
            return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    _unref(scrollTop) > 0 && !_unref(route).meta.fixNav ? '-translate-y-20' : 'translate-y-0',
                    'header-wrap top-0 sticky min-h-full z-1500 transition-all bg-gradient-to-r from-[#f9fbff] to-[#e6f0fc]'
                ])
            }, [
                _createVNode(_unref(Disclosure), {
                    as: "nav"
                }, {
                    default: _withCtx((param)=>{
                        let { open } = param;
                        return [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_router_link, {
                                            to: "/",
                                            class: "h-full"
                                        }, {
                                            default: _withCtx(()=>[
                                                    ..._cache[3] || (_cache[3] = [
                                                        _createElementVNode("img", {
                                                            src: _imports_0,
                                                            class: "w-full max-w-50 object-cover",
                                                            alt: ""
                                                        }, null, -1)
                                                    ])
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([
                                                "flex -my-px",
                                                [
                                                    _unref(route).path === '/home' && '!text-black'
                                                ]
                                            ])
                                        }, [
                                            _createVNode(_unref(PopoverGroup), {
                                                class: "popover-group"
                                            }, {
                                                default: _withCtx(()=>[
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item)=>{
                                                            return _createElementVNode("div", {
                                                                key: item.name,
                                                                class: "flex items-center justify-center"
                                                            }, [
                                                                item.children ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 0,
                                                                    class: "relative",
                                                                    onMouseenter: ($event)=>hoveredNav.value = item.name,
                                                                    onMouseleave: _cache[0] || (_cache[0] = ($event)=>hoveredNav.value = null)
                                                                }, [
                                                                    _createVNode(_component_router_link, {
                                                                        to: item.href,
                                                                        class: _normalizeClass([
                                                                            'nav-item',
                                                                            getNavActiveClass(item),
                                                                            'inline-flex items-center border-b-0 px-1 outline-0 gap-1'
                                                                        ]),
                                                                        "aria-current": isActive(item) ? 'page' : undefined
                                                                    }, {
                                                                        default: _withCtx(()=>[
                                                                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                                                                _createVNode(_unref(ChevronDownIcon), {
                                                                                    class: _normalizeClass([
                                                                                        {
                                                                                            'rotate-180 transform': hoveredNav.value === item.name
                                                                                        },
                                                                                        "flex-none transition duration-200 size-5 stroke-2"
                                                                                    ]),
                                                                                    "aria-hidden": "true"
                                                                                }, null, 8, [
                                                                                    "class"
                                                                                ])
                                                                            ]),
                                                                        _: 2
                                                                    }, 1032, [
                                                                        "to",
                                                                        "class",
                                                                        "aria-current"
                                                                    ]),
                                                                    _createVNode(_Transition, {
                                                                        "enter-active-class": "transition duration-200 ease-out",
                                                                        "enter-from-class": "translate-y-1 opacity-0",
                                                                        "enter-to-class": "translate-y-0 opacity-100",
                                                                        "leave-active-class": "transition duration-150 ease-in",
                                                                        "leave-from-class": "translate-y-0 opacity-100",
                                                                        "leave-to-class": "translate-y-1 opacity-0"
                                                                    }, {
                                                                        default: _withCtx(()=>[
                                                                                _withDirectives(_createElementVNode("div", _hoisted_5, [
                                                                                    _createElementVNode("div", _hoisted_6, [
                                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itm)=>{
                                                                                            return _openBlock(), _createBlock(_component_router_link, {
                                                                                                key: itm.name,
                                                                                                to: itm.href,
                                                                                                class: _normalizeClass([
                                                                                                    'block whitespace-nowrap px-5 py-2 text-sm hover:text-blue-500 hover:bg-gray-50',
                                                                                                    isActive(itm) ? 'text-blue-500 bg-gray-50 font-medium' : 'text-gray-600'
                                                                                                ])
                                                                                            }, {
                                                                                                default: _withCtx(()=>[
                                                                                                        _createTextVNode(_toDisplayString(itm.name), 1)
                                                                                                    ]),
                                                                                                _: 2
                                                                                            }, 1032, [
                                                                                                "to",
                                                                                                "class"
                                                                                            ]);
                                                                                        }), 128))
                                                                                    ])
                                                                                ], 512), [
                                                                                    [
                                                                                        _vShow,
                                                                                        hoveredNav.value === item.name
                                                                                    ]
                                                                                ])
                                                                            ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ], 40, _hoisted_4)) : (_openBlock(), _createBlock(_component_router_link, {
                                                                    key: 1,
                                                                    to: item.href,
                                                                    class: _normalizeClass([
                                                                        'nav-item',
                                                                        getNavActiveClass(item),
                                                                        'inline-flex items-center border-b-0 px-1'
                                                                    ]),
                                                                    "aria-current": isActive(item) ? 'page' : undefined
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            _createTextVNode(_toDisplayString(item.name), 1)
                                                                        ]),
                                                                    _: 2
                                                                }, 1032, [
                                                                    "to",
                                                                    "class",
                                                                    "aria-current"
                                                                ]))
                                                            ]);
                                                        }), 64))
                                                    ]),
                                                _: 1
                                            })
                                        ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_el_tooltip, {
                                            content: "数据空间驾驶舱"
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createVNode(_component_router_link, {
                                                        to: "/dataview/data-space",
                                                        class: "cockpit-btn cursor-pointer whitespace-nowrap py-2 px-4 rounded-full text-sm font-medium flex items-center gap-2"
                                                    }, {
                                                        default: _withCtx(()=>[
                                                                ..._cache[4] || (_cache[4] = [
                                                                    _createElementVNode("img", {
                                                                        class: "w-4 h-4",
                                                                        src: _imports_1,
                                                                        alt: "",
                                                                        srcset: ""
                                                                    }, null, -1),
                                                                    _createTextVNode(" 驾驶舱 ", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_tooltip, {
                                            content: "工作台"
                                        }, {
                                            default: _withCtx(()=>[
                                                    _createElementVNode("div", {
                                                        class: "workflow-btn-container cursor-pointer whitespace-nowrap py-2 px-4 rounded-full text-sm font-medium flex items-center gap-2",
                                                        onClick: goEntCenter
                                                    }, [
                                                        ..._cache[5] || (_cache[5] = [
                                                            _createElementVNode("img", {
                                                                class: "w-4 h-4",
                                                                src: _imports_2,
                                                                alt: "",
                                                                srcset: ""
                                                            }, null, -1),
                                                            _createTextVNode(" 工作台 ", -1)
                                                        ])
                                                    ])
                                                ]),
                                            _: 1
                                        }),
                                        _unref(userStore).name ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("img", {
                                                    id: _unref(NAV_CART_ID),
                                                    src: _imports_3,
                                                    class: "w-[24px] cursor-pointer",
                                                    "aria-hidden": "true",
                                                    onClick: goCart
                                                }, null, 8, _hoisted_10),
                                                cartCount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(cartCount.value > 99 ? '99+' : cartCount.value), 1)) : _createCommentVNode("", true)
                                            ])
                                        ])) : _createCommentVNode("", true),
                                        _unref(userStore).name ? (_openBlock(), _createBlock(_component_el_popover, {
                                            key: 1,
                                            visible: showAccount.value,
                                            "onUpdate:visible": _cache[1] || (_cache[1] = ($event)=>showAccount.value = $event),
                                            placement: "bottom-end",
                                            width: 336,
                                            "show-arrow": false,
                                            trigger: "click",
                                            onShow: handleShowAccount,
                                            onHide: _cache[2] || (_cache[2] = ($event)=>isAccountPopupHide.value = true)
                                        }, {
                                            reference: _withCtx(()=>[
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createVNode(_unref(OverflowTooltip), {
                                                            content: name.value
                                                        }, {
                                                            default: _withCtx(()=>[
                                                                    _createElementVNode("div", _hoisted_13, [
                                                                        _createElementVNode("span", {
                                                                            id: "name",
                                                                            ref: "nameRef",
                                                                            class: "line-clamp-1"
                                                                        }, _toDisplayString(name.value), 513)
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }, 8, [
                                                            "content"
                                                        ]),
                                                        _createVNode(_unref(ElIcon), {
                                                            class: "cursor-pointer ml-[4px]",
                                                            color: "#3284ff"
                                                        }, {
                                                            default: _withCtx(()=>[
                                                                    _withDirectives(_createVNode(_unref(CaretTop), null, null, 512), [
                                                                        [
                                                                            _vShow,
                                                                            !isAccountPopupHide.value
                                                                        ]
                                                                    ]),
                                                                    _withDirectives(_createVNode(_unref(CaretBottom), null, null, 512), [
                                                                        [
                                                                            _vShow,
                                                                            isAccountPopupHide.value
                                                                        ]
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        })
                                                    ])
                                                ]),
                                            default: _withCtx(()=>[
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_14, [
                                                            _cache[6] || (_cache[6] = _createElementVNode("div", {
                                                                class: "text-14px color-#666 font-400 mb-[8px]"
                                                            }, " 个人账号 ", -1)),
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass([
                                                                    "btn-common mb-[12px]",
                                                                    currentDeptId.value === userDepId.value ? 'btn-active' : ''
                                                                ]),
                                                                onClick: handlePersonClick
                                                            }, [
                                                                _createTextVNode(_toDisplayString(_unref(userStore).nickName) + " ", 1),
                                                                currentDeptId.value === userDepId.value ? (_openBlock(), _createBlock(_unref(ElIcon), {
                                                                    key: 0,
                                                                    class: "checked-wrapper",
                                                                    size: 10,
                                                                    color: "#3ABBFF"
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            _createVNode(_unref(Select))
                                                                        ]),
                                                                    _: 1
                                                                })) : _createCommentVNode("", true)
                                                            ], 2),
                                                            _cache[7] || (_cache[7] = _createElementVNode("div", {
                                                                class: "text-14px color-#666 font-400 mb-[8px]"
                                                            }, " 已注册的企业/组织 ", -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enterpriseList.value, (item)=>{
                                                                return _openBlock(), _createElementBlock("div", {
                                                                    key: item.deptId,
                                                                    class: _normalizeClass([
                                                                        "btn-common mb-[8px]",
                                                                        currentDeptId.value === item.deptId ? 'btn-active' : ''
                                                                    ]),
                                                                    onClick: ($event)=>handleEnterpriseClick(item.deptId)
                                                                }, [
                                                                    _createTextVNode(_toDisplayString(item.deptName) + " ", 1),
                                                                    currentDeptId.value === item.deptId ? (_openBlock(), _createBlock(_unref(ElIcon), {
                                                                        key: 0,
                                                                        class: "checked-wrapper",
                                                                        size: 10,
                                                                        color: "#3ABBFF"
                                                                    }, {
                                                                        default: _withCtx(()=>[
                                                                                _createVNode(_unref(Select))
                                                                            ]),
                                                                        _: 1
                                                                    })) : _createCommentVNode("", true)
                                                                ], 10, _hoisted_15);
                                                            }), 128))
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: "btn-common !border-none !mt-[16px]",
                                                            onClick: loginOut
                                                        }, " 退出 ")
                                                    ])
                                                ]),
                                            _: 1
                                        }, 8, [
                                            "visible"
                                        ])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createVNode(_component_router_link, {
                                                class: "login-btn h-full cursor-pointer whitespace-nowrap py-2 px-6 text-base font-medium",
                                                to: "/login"
                                            }, {
                                                default: _withCtx(()=>[
                                                        ..._cache[8] || (_cache[8] = [
                                                            _createTextVNode("登录", -1)
                                                        ])
                                                    ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_router_link, {
                                                class: "register-btn h-full cursor-pointer whitespace-nowrap py-2 px-6 text-base font-medium",
                                                to: "/register"
                                            }, {
                                                default: _withCtx(()=>[
                                                        ..._cache[9] || (_cache[9] = [
                                                            _createTextVNode(" 注册 ", -1)
                                                        ])
                                                    ]),
                                                _: 1
                                            })
                                        ]))
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_unref(DisclosureButton), {
                                            class: "relative inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-md hover:bg-gray-100 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
                                        }, {
                                            default: _withCtx(()=>[
                                                    _cache[10] || (_cache[10] = _createElementVNode("span", {
                                                        class: "absolute -inset-0.5"
                                                    }, null, -1)),
                                                    _cache[11] || (_cache[11] = _createElementVNode("span", {
                                                        class: "sr-only"
                                                    }, "Open main menu", -1)),
                                                    !open ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                                                        key: 0,
                                                        class: "block size-6",
                                                        "aria-hidden": "true"
                                                    })) : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                                                        key: 1,
                                                        class: "block size-6",
                                                        "aria-hidden": "true"
                                                    }))
                                                ]),
                                            _: 2
                                        }, 1024)
                                    ])
                                ])
                            ]),
                            _createVNode(_unref(DisclosurePanel), {
                                class: "xl:hidden"
                            }, {
                                default: _withCtx(()=>[
                                        _createElementVNode("div", _hoisted_18, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item)=>{
                                                return _createVNode(_unref(DisclosureButton), {
                                                    key: item.name,
                                                    as: "a",
                                                    href: item.href,
                                                    class: _normalizeClass([
                                                        isActive(item) ? 'border-indigo-500 bg-indigo-50 text-indigo-700' : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800',
                                                        'block border-l-4 py-2 pr-4 pl-3 text-base font-medium'
                                                    ]),
                                                    "aria-current": isActive(item) ? 'page' : undefined
                                                }, {
                                                    default: _withCtx(()=>[
                                                            _createTextVNode(_toDisplayString(item.name), 1)
                                                        ]),
                                                    _: 2
                                                }, 1032, [
                                                    "href",
                                                    "class",
                                                    "aria-current"
                                                ]);
                                            }), 64))
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createVNode(_component_router_link, {
                                                    to: "/dataview/data-space",
                                                    class: "cockpit-btn flex-1 text-center cursor-pointer text-sm font-medium flex items-center justify-center gap-2"
                                                }, {
                                                    default: _withCtx(()=>[
                                                            ..._cache[12] || (_cache[12] = [
                                                                _createElementVNode("svg", {
                                                                    class: "w-4 h-4",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    "stroke-width": "2"
                                                                }, [
                                                                    _createElementVNode("path", {
                                                                        d: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
                                                                        "stroke-linecap": "round",
                                                                        "stroke-linejoin": "round"
                                                                    })
                                                                ], -1),
                                                                _createTextVNode(" 驾驶舱 ", -1)
                                                            ])
                                                        ]),
                                                    _: 1
                                                }),
                                                _createElementVNode("div", {
                                                    class: "workflow-btn-container flex-1 text-center cursor-pointer text-sm font-medium flex items-center justify-center gap-2",
                                                    onClick: goEntCenter
                                                }, [
                                                    ..._cache[13] || (_cache[13] = [
                                                        _createElementVNode("svg", {
                                                            class: "w-4 h-4",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2"
                                                        }, [
                                                            _createElementVNode("rect", {
                                                                x: "2",
                                                                y: "3",
                                                                width: "20",
                                                                height: "14",
                                                                rx: "2"
                                                            }),
                                                            _createElementVNode("path", {
                                                                d: "M8 21h8M12 17v4",
                                                                "stroke-linecap": "round"
                                                            })
                                                        ], -1),
                                                        _createTextVNode(" 工作台 ", -1)
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _unref(userStore).name ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("img", {
                                                        class: "rounded-full size-10",
                                                        src: _unref(userStore).avatar || defaultAvatarSvg,
                                                        alt: ""
                                                    }, null, 8, _hoisted_24)
                                                ]),
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(userStore).name), 1),
                                                    _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(userStore).email), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", {
                                                class: "mt-3 space-y-1"
                                            }, [
                                                _createElementVNode("div", {
                                                    class: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800 cursor-pointer",
                                                    onClick: loginOut
                                                }, " 退出登录 ")
                                            ])
                                        ])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _createVNode(_component_router_link, {
                                                    class: "login-btn flex-1 text-center cursor-pointer rounded-full text-sm font-medium",
                                                    to: "/login"
                                                }, {
                                                    default: _withCtx(()=>[
                                                            ..._cache[14] || (_cache[14] = [
                                                                _createTextVNode("登录", -1)
                                                            ])
                                                        ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_router_link, {
                                                    class: "register-btn flex-1 text-center cursor-pointer rounded-full text-sm font-medium",
                                                    to: "/register"
                                                }, {
                                                    default: _withCtx(()=>[
                                                            ..._cache[15] || (_cache[15] = [
                                                                _createTextVNode("注册", -1)
                                                            ])
                                                        ]),
                                                    _: 1
                                                })
                                            ])
                                        ]))
                                    ]),
                                _: 1
                            })
                        ];
                    }),
                    _: 1
                })
            ], 2);
        };
    }
};
